"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SigningStargateClient = exports.defaultRegistryTypes = void 0;
const amino_1 = require("@cosmjs/amino");
const encoding_1 = require("@cosmjs/encoding");
const math_1 = require("@cosmjs/math");
//xxl swift package
const proto_signing_1 = require("@uptsmart/proto-signing");
//xxl swift local
// import {
//   EncodeObject,
//   encodePubkey,
//   GeneratedType,
//   isOfflineDirectSigner,
//   makeAuthInfoBytes,
//   makeSignDoc,
//   OfflineSigner,
//   Registry,
//   TxBodyEncodeObject,
// } from "../../proto-signing";
const tendermint_rpc_1 = require("@cosmjs/tendermint-rpc");
const utils_1 = require("@cosmjs/utils");
const tx_1 = require("cosmjs-types/cosmos/authz/v1beta1/tx");
const tx_2 = require("cosmjs-types/cosmos/bank/v1beta1/tx");
const coin_1 = require("cosmjs-types/cosmos/base/v1beta1/coin");
const tx_3 = require("cosmjs-types/cosmos/distribution/v1beta1/tx");
const tx_4 = require("cosmjs-types/cosmos/feegrant/v1beta1/tx");
const tx_5 = require("cosmjs-types/cosmos/gov/v1beta1/tx");
const tx_6 = require("cosmjs-types/cosmos/staking/v1beta1/tx");
const signing_1 = require("cosmjs-types/cosmos/tx/signing/v1beta1/signing");
const tx_7 = require("cosmjs-types/cosmos/tx/v1beta1/tx");
const tx_8 = require("cosmjs-types/ibc/applications/transfer/v1/tx");
const tx_9 = require("cosmjs-types/ibc/core/channel/v1/tx");
const tx_10 = require("cosmjs-types/ibc/core/client/v1/tx");
const tx_11 = require("cosmjs-types/ibc/core/connection/v1/tx");
//xxl ## import 
//const nft_tx_pb= require( './proto-types/uptick/collection/v1/tx_pb');
//const nft_tx_pb = require( '../../proto-types/uptick/collection/v1/tx_pb');
const nft_tx_pb = require("@uptsmart/proto-types/src/uptick/collection/v1/tx_pb");
//xxl ## add erc20 convert msg 0622
const erc20_tx_pb = require("@uptsmart/proto-types/src/uptick/erc20/v1/tx_pb");
//xxl 02 local
// const erc721_tx_pb = require("../../proto-types/src/uptick/erc721/v1/tx_pb")
//xxl 02 npm
const erc721_tx_pb = require("@uptsmart/proto-types/src/uptick/erc721/v1/tx_pb");
//xxl 02 local
// const nft_transfer_tx_pb = require("../../proto-types/src/ibc/applications/nft_transfer/v1/tx_pb")
//xxl 02 npm
const nft_transfer_tx_pb = require("@uptsmart/proto-types/src/ibc/applications/nft_transfer/v1/tx_pb");
//xxl 03
const cw721_tx_pb = require("@uptsmart/proto-types/src/uptick/cw721/v1/tx_pb");
const long_1 = __importDefault(require("long"));
const aminotypes_1 = require("./aminotypes");
const fee_1 = require("./fee");
const stargateclient_1 = require("./stargateclient");
exports.defaultRegistryTypes = [
    ["/cosmos.authz.v1beta1.MsgExec", tx_1.MsgExec],
    ["/cosmos.authz.v1beta1.MsgGrant", tx_1.MsgGrant],
    ["/cosmos.authz.v1beta1.MsgRevoke", tx_1.MsgRevoke],
    ["/cosmos.bank.v1beta1.MsgMultiSend", tx_2.MsgMultiSend],
    ["/cosmos.bank.v1beta1.MsgSend", tx_2.MsgSend],
    ["/cosmos.base.v1beta1.Coin", coin_1.Coin],
    ["/cosmos.distribution.v1beta1.MsgFundCommunityPool", tx_3.MsgFundCommunityPool],
    ["/cosmos.distribution.v1beta1.MsgSetWithdrawAddress", tx_3.MsgSetWithdrawAddress],
    ["/cosmos.distribution.v1beta1.MsgWithdrawDelegatorReward", tx_3.MsgWithdrawDelegatorReward],
    ["/cosmos.distribution.v1beta1.MsgWithdrawValidatorCommission", tx_3.MsgWithdrawValidatorCommission],
    ["/cosmos.feegrant.v1beta1.MsgGrantAllowance", tx_4.MsgGrantAllowance],
    ["/cosmos.feegrant.v1beta1.MsgRevokeAllowance", tx_4.MsgRevokeAllowance],
    ["/cosmos.gov.v1beta1.MsgDeposit", tx_5.MsgDeposit],
    ["/cosmos.gov.v1beta1.MsgSubmitProposal", tx_5.MsgSubmitProposal],
    ["/cosmos.gov.v1beta1.MsgVote", tx_5.MsgVote],
    ["/cosmos.staking.v1beta1.MsgBeginRedelegate", tx_6.MsgBeginRedelegate],
    ["/cosmos.staking.v1beta1.MsgCreateValidator", tx_6.MsgCreateValidator],
    ["/cosmos.staking.v1beta1.MsgDelegate", tx_6.MsgDelegate],
    ["/cosmos.staking.v1beta1.MsgEditValidator", tx_6.MsgEditValidator],
    ["/cosmos.staking.v1beta1.MsgUndelegate", tx_6.MsgUndelegate],
    ["/ibc.applications.transfer.v1.MsgTransfer", tx_8.MsgTransfer],
    ["/ibc.core.channel.v1.MsgAcknowledgement", tx_9.MsgAcknowledgement],
    ["/ibc.core.channel.v1.MsgChannelCloseConfirm", tx_9.MsgChannelCloseConfirm],
    ["/ibc.core.channel.v1.MsgChannelCloseInit", tx_9.MsgChannelCloseInit],
    ["/ibc.core.channel.v1.MsgChannelOpenAck", tx_9.MsgChannelOpenAck],
    ["/ibc.core.channel.v1.MsgChannelOpenConfirm", tx_9.MsgChannelOpenConfirm],
    ["/ibc.core.channel.v1.MsgChannelOpenInit", tx_9.MsgChannelOpenInit],
    ["/ibc.core.channel.v1.MsgChannelOpenTry", tx_9.MsgChannelOpenTry],
    ["/ibc.core.channel.v1.MsgRecvPacket", tx_9.MsgRecvPacket],
    ["/ibc.core.channel.v1.MsgTimeout", tx_9.MsgTimeout],
    ["/ibc.core.channel.v1.MsgTimeoutOnClose", tx_9.MsgTimeoutOnClose],
    ["/ibc.core.client.v1.MsgCreateClient", tx_10.MsgCreateClient],
    ["/ibc.core.client.v1.MsgSubmitMisbehaviour", tx_10.MsgSubmitMisbehaviour],
    ["/ibc.core.client.v1.MsgUpdateClient", tx_10.MsgUpdateClient],
    ["/ibc.core.client.v1.MsgUpgradeClient", tx_10.MsgUpgradeClient],
    ["/ibc.core.connection.v1.MsgConnectionOpenAck", tx_11.MsgConnectionOpenAck],
    ["/ibc.core.connection.v1.MsgConnectionOpenConfirm", tx_11.MsgConnectionOpenConfirm],
    ["/ibc.core.connection.v1.MsgConnectionOpenInit", tx_11.MsgConnectionOpenInit],
    ["/ibc.core.connection.v1.MsgConnectionOpenTry", tx_11.MsgConnectionOpenTry],
    //xxl 01 list 
    ["/uptick.collection.v1.MsgIssueDenom", nft_tx_pb.MsgIssueDenom],
    ["/uptick.collection.v1.MsgMintNFT", nft_tx_pb.MsgMintNFT],
    ["/uptick.collection.v1.MsgTransferNFT", nft_tx_pb.MsgTransferNFT],
    ["/uptick.collection.v1.MsgTransferDenom", nft_tx_pb.MsgTransferDenom],
    ["/uptick.erc20.v1.MsgConvertERC20", erc20_tx_pb.MsgConvertERC20],
    ["/uptick.erc20.v1.MsgConvertCoin", erc20_tx_pb.MsgConvertCoin],
    ["/uptick.erc20.v1.MsgTransferERC20", erc20_tx_pb.MsgTransferERC20],
    //xxl 02 list 
    ["/uptick.erc721.v1.MsgConvertERC721", erc721_tx_pb.MsgConvertERC721],
    ["/uptick.erc721.v1.MsgConvertNFT", erc721_tx_pb.MsgConvertNFT],
    ["/uptick.erc721.v1.MsgTransferERC721", erc721_tx_pb.MsgTransferERC721],
    //xxl 03 list 
    ["/ibc.applications.nft_transfer.v1.MsgTransfer", nft_transfer_tx_pb.MsgTransfer],
    //xxl 04 list 
    ["/uptick.cw721.v1.MsgConvertCW721", cw721_tx_pb.MsgConvertCW721],
    ["/uptick.cw721.v1.MsgConvertNFT", cw721_tx_pb.MsgConvertNFT],
    ["/uptick.cw721.v1.MsgTransferCW721", cw721_tx_pb.MsgTransferCW721],
];
function createDefaultRegistry() {
    return new proto_signing_1.Registry(exports.defaultRegistryTypes);
}
class SigningStargateClient extends stargateclient_1.StargateClient {
    constructor(tmClient, signer, options) {
        var _a;
        super(tmClient);
        // TODO: do we really want to set a default here? Ideally we could get it from the signer such that users only have to set it once.
        const prefix = (_a = options.prefix) !== null && _a !== void 0 ? _a : "cosmos";
        const { registry = createDefaultRegistry(), aminoTypes = new aminotypes_1.AminoTypes({ prefix }) } = options;
        this.registry = registry;
        this.aminoTypes = aminoTypes;
        this.signer = signer;
        this.broadcastTimeoutMs = options.broadcastTimeoutMs;
        this.broadcastPollIntervalMs = options.broadcastPollIntervalMs;
        this.gasPrice = options.gasPrice;
		
    }
    static async connectWithSigner(endpoint, signer, options = {}) {
        const tmClient = await tendermint_rpc_1.Tendermint37Client.connect(endpoint);
        return new SigningStargateClient(tmClient, signer, options);
    }
    /**
     * Creates a client in offline mode.
     *
     * This should only be used in niche cases where you know exactly what you're doing,
     * e.g. when building an offline signing application.
     *
     * When you try to use online functionality with such a signer, an
     * exception will be raised.
     */
    static async offline(signer, options = {}) {
        return new SigningStargateClient(undefined, signer, options);
    }
    async simulate(signerAddress, messages, memo) {
        const anyMsgs = messages.map((m) => this.registry.encodeAsAny(m));
        const accountFromSigner = (await this.signer.getAccounts()).find((account) => account.address === signerAddress);
        if (!accountFromSigner) {
            throw new Error("Failed to retrieve account from signer");
        }
        const pubkey = (0, amino_1.encodeSecp256k1Pubkey)(accountFromSigner.pubkey);
        const { sequence } = await this.getSequence(signerAddress);
        const { gasInfo } = await this.forceGetQueryClient().tx.simulate(anyMsgs, memo, pubkey, sequence);
        (0, utils_1.assertDefined)(gasInfo);
        return math_1.Uint53.fromString(gasInfo.gasUsed.toString()).toNumber();
    }
    async sendTokens(senderAddress, recipientAddress, amount, fee, memo = "") {
        const sendMsg = {
            typeUrl: "/cosmos.bank.v1beta1.MsgSend",
            value: {
                fromAddress: senderAddress,
                toAddress: recipientAddress,
                amount: [...amount],
            },
        };
        return this.signAndBroadcast(senderAddress, [sendMsg], fee, memo);
    }
    //xxl #### public async sendMsgsTx
    async sendMsgsTx(senderAddress, sendMsgs, fee, memo = "") {
        console.log("xxl test ");
        return this.signAndBroadcast(senderAddress, sendMsgs, fee, memo);
    }
    async delegateTokens(delegatorAddress, validatorAddress, amount, fee, memo = "") {
        const delegateMsg = {
            typeUrl: "/cosmos.staking.v1beta1.MsgDelegate",
            value: tx_6.MsgDelegate.fromPartial({
                delegatorAddress: delegatorAddress,
                validatorAddress: validatorAddress,
                amount: amount,
            }),
        };
        return this.signAndBroadcast(delegatorAddress, [delegateMsg], fee, memo);
    }
    async reDelegateTokens(delegatorAddress, validatorSrcAddress, validatorDstAddress, amount, fee, memo = "") {
        const reDelegateMsg = {
            typeUrl: "/cosmos.staking.v1beta1.MsgBeginRedelegate",
            value: tx_6.MsgBeginRedelegate.fromPartial({
                delegatorAddress: delegatorAddress,
                validatorSrcAddress: validatorSrcAddress,
                validatorDstAddress: validatorDstAddress,
                amount: amount,
            }),
        };
        return this.signAndBroadcast(delegatorAddress, [reDelegateMsg], fee, memo);
    }
    async undelegateTokens(delegatorAddress, validatorAddress, amount, fee, memo = "") {
        const undelegateMsg = {
            typeUrl: "/cosmos.staking.v1beta1.MsgUndelegate",
            value: tx_6.MsgUndelegate.fromPartial({
                delegatorAddress: delegatorAddress,
                validatorAddress: validatorAddress,
                amount: amount,
            }),
        };
        return this.signAndBroadcast(delegatorAddress, [undelegateMsg], fee, memo);
    }
    async withdrawRewards(delegatorAddress, validatorAddress, fee, memo = "") {
        const withdrawMsg = {
            typeUrl: "/cosmos.distribution.v1beta1.MsgWithdrawDelegatorReward",
            value: tx_3.MsgWithdrawDelegatorReward.fromPartial({
                delegatorAddress: delegatorAddress,
                validatorAddress: validatorAddress,
            }),
        };
        return this.signAndBroadcast(delegatorAddress, [withdrawMsg], fee, memo);
    }
    async withdrawRewardsAll(delegatorAddress, validatorAddressList, fee, memo = "") {
        let withdrawMsgs = [];
        validatorAddressList.forEach(validatorAddress => {
            const withdrawMsg = {
                typeUrl: "/cosmos.distribution.v1beta1.MsgWithdrawDelegatorReward",
                value: tx_3.MsgWithdrawDelegatorReward.fromPartial({
                    delegatorAddress: delegatorAddress,
                    validatorAddress: validatorAddress,
                }),
            };
            withdrawMsgs.push(withdrawMsg);
        });
        return this.signAndBroadcast(delegatorAddress, withdrawMsgs, fee, memo);
    }
    async vote(voterAddress, proposalId, option, fee, memo = "") {
        // VOTE_OPTION_UNSPECIFIED = 0,
        // VOTE_OPTION_YES = 1,
        // VOTE_OPTION_ABSTAIN = 2,
        // VOTE_OPTION_NO = 3,
        // VOTE_OPTION_NO_WITH_VETO = 4,
        // UNRECOGNIZED = -1
        const voteMsg = {
            typeUrl: "/cosmos.gov.v1beta1.MsgVote",
            value: tx_5.MsgVote.fromPartial({
                proposalId: proposalId,
                voter: voterAddress,
                option: option
            }),
        };
        return this.signAndBroadcast(voterAddress, [voteMsg], fee, memo);
    }
    async sendIbcTokens(senderAddress, recipientAddress, transferAmount, sourcePort, sourceChannel, timeoutHeight, 
    /** timeout in seconds */
    timeoutTimestamp, fee, memo = "") {
        const timeoutTimestampNanoseconds = timeoutTimestamp
            ? long_1.default.fromNumber(timeoutTimestamp).multiply(1000000000)
            : undefined;
        const transferMsg = {
            typeUrl: "/ibc.applications.transfer.v1.MsgTransfer",
            value: tx_8.MsgTransfer.fromPartial({
                sourcePort: sourcePort,
                sourceChannel: sourceChannel,
                sender: senderAddress,
                receiver: recipientAddress,
                token: transferAmount,
                timeoutHeight: timeoutHeight,
                timeoutTimestamp: timeoutTimestampNanoseconds,
            }),
        };
        return this.signAndBroadcast(senderAddress, [transferMsg], fee, memo);
    }
    async signAndBroadcast(signerAddress, messages, fee, memo = "") {
        let usedFee;
        if (fee == "auto" || typeof fee === "number") {
            (0, utils_1.assertDefined)(this.gasPrice, "Gas price must be set in the client options when auto gas is used.");
            const gasEstimation = await this.simulate(signerAddress, messages, memo);
            const muliplier = typeof fee === "number" ? fee : 1.3;
            usedFee = (0, fee_1.calculateFee)(Math.round(gasEstimation * muliplier), this.gasPrice);
        }
        else {
            usedFee = fee;
        }
        const txRaw = await this.sign(signerAddress, messages, usedFee, memo);
        const txBytes = tx_7.TxRaw.encode(txRaw).finish();
        return this.broadcastTx(txBytes, this.broadcastTimeoutMs, this.broadcastPollIntervalMs);
    }
    /**
     * Gets account number and sequence from the API, creates a sign doc,
     * creates a single signature and assembles the signed transaction.
     *
     * The sign mode (SIGN_MODE_DIRECT or SIGN_MODE_LEGACY_AMINO_JSON) is determined by this client's signer.
     *
     * You can pass signer data (account number, sequence and chain ID) explicitly instead of querying them
     * from the chain. This is needed when signing for a multisig account, but it also allows for offline signing
     * (See the SigningStargateClient.offline constructor).
     */
    async sign(signerAddress, messages, fee, memo, explicitSignerData) {
        let signerData;
        if (explicitSignerData) {
            signerData = explicitSignerData;
        }
        else {
            const { accountNumber, sequence } = await this.getSequence(signerAddress);
            const chainId = await this.getChainId();
            signerData = {
                accountNumber: accountNumber,
                sequence: sequence,
                chainId: chainId,
            };
        }
        return (0, proto_signing_1.isOfflineDirectSigner)(this.signer)
            ? this.signDirect(signerAddress, messages, fee, memo, signerData)
            : this.signAmino(signerAddress, messages, fee, memo, signerData);
    }
    async signAmino(signerAddress, messages, fee, memo, { accountNumber, sequence, chainId }) {
        (0, utils_1.assert)(!(0, proto_signing_1.isOfflineDirectSigner)(this.signer));
        const accountFromSigner = (await this.signer.getAccounts()).find((account) => account.address === signerAddress);
        if (!accountFromSigner) {
            throw new Error("Failed to retrieve account from signer");
        }
        const pubkey = (0, proto_signing_1.encodePubkey)((0, amino_1.encodeSecp256k1Pubkey)(accountFromSigner.pubkey));
        const signMode = signing_1.SignMode.SIGN_MODE_LEGACY_AMINO_JSON;
        const msgs = messages.map((msg) => this.aminoTypes.toAmino(msg));
        const signDoc = (0, amino_1.makeSignDoc)(msgs, fee, chainId, memo, accountNumber, sequence);
        const { signature, signed } = await this.signer.signAmino(signerAddress, signDoc);
      
		const signedTxBody = {
            messages: signed.msgs.map((msg) => this.aminoTypes.fromAmino(msg)),
            memo: signed.memo,
        };
        const signedTxBodyEncodeObject = {
            typeUrl: "/cosmos.tx.v1beta1.TxBody",
            value: signedTxBody,
        };
        const signedTxBodyBytes = this.registry.encode(signedTxBodyEncodeObject);
        const signedGasLimit = math_1.Int53.fromString(signed.fee.gas).toNumber();
        const signedSequence = math_1.Int53.fromString(signed.sequence).toNumber();
        const signedAuthInfoBytes = (0, proto_signing_1.makeAuthInfoBytes)([{ pubkey, sequence: signedSequence }], signed.fee.amount, signedGasLimit, signMode);
        return tx_7.TxRaw.fromPartial({
            bodyBytes: signedTxBodyBytes,
            authInfoBytes: signedAuthInfoBytes,
            signatures: [(0, encoding_1.fromBase64)(signature.signature)],
        });
    }
    async signDirect(signerAddress, messages, fee, memo, { accountNumber, sequence, chainId }) {
        (0, utils_1.assert)((0, proto_signing_1.isOfflineDirectSigner)(this.signer));
        const accountFromSigner = (await this.signer.getAccounts()).find((account) => account.address === signerAddress);
        if (!accountFromSigner) {
            throw new Error("Failed to retrieve account from signer");
        }
        const pubkey = (0, proto_signing_1.encodePubkey)((0, amino_1.encodeSecp256k1Pubkey)(accountFromSigner.pubkey));
        if (accountFromSigner.address.indexOf("uptick") != -1) {
            pubkey.typeUrl = "/ethermint.crypto.v1.ethsecp256k1.PubKey";
        }
        else {
            pubkey.typeUrl = "/cosmos.crypto.secp256k1.PubKey";
        }
        const txBodyEncodeObject = {
            typeUrl: "/cosmos.tx.v1beta1.TxBody",
            value: {
                messages: messages,
                memo: memo,
            },
        };
		
        const txBodyBytes = this.registry.encode(txBodyEncodeObject);
        const gasLimit = math_1.Int53.fromString(fee.gas).toNumber();
        const authInfoBytes = (0, proto_signing_1.makeAuthInfoBytes)([{ pubkey, sequence }], fee.amount, gasLimit);
        const signDoc = (0, proto_signing_1.makeSignDoc)(txBodyBytes, authInfoBytes, chainId, accountNumber);
        const { signature, signed } = await this.signer.signDirect(signerAddress, signDoc);
        return tx_7.TxRaw.fromPartial({
            bodyBytes: signed.bodyBytes,
            authInfoBytes: signed.authInfoBytes,
            signatures: [(0, encoding_1.fromBase64)(signature.signature)],
        });
    }
}
exports.SigningStargateClient = SigningStargateClient;
//# sourceMappingURL=signingstargateclient.js.map